import { isSameDay } from 'date-fns'
import { parseDate } from '../parseDate'

export const isSameDays = (...dateStrings: [string, ...string[]]): boolean => {
  const parsedDates = dateStrings.map(parseDate) as [Date, ...Date[]]
  if (parsedDates.some((parsedDate) => !parsedDate)) {
    throw new Error('Invalid date string')
  }
  return parsedDates.every((date) => isSameDay(parsedDates[0], date))
}
